import React from 'react';
import ImageUploader from "../ImageUpload/ImageUploader";
import CircularProgress from 'material-ui/CircularProgress';
import Solution from './Solution';
import ReactTooltip from 'react-tooltip';
import CustomEditor from "../CustomEditor/CustomEditor";
import WirisEditor from '../WirisEditor/WirisEditor';

var ShortQuestionEditor = React.createClass({
  handlePreTextChange: function(e) {
    var kquestion = this.state.kquestion;
    kquestion.textInputAnswers[0].preText = e.target.value;
  },
  handlePostTextChange: function(e) {
    var kquestion = this.state.kquestion;
    kquestion.textInputAnswers[0].postText = e.target.value;
  },
  handleAnswerChange: function(e) {
    var kquestion = this.state.kquestion;
    kquestion.textInputAnswers[0].text = e.target.value;
  },

  handleAnswerChangeWiris: function(e) {
    var kquestion = this.state.kquestion;
    kquestion.textInputAnswers[0].text = e;
  },
  handleDescriptionChange: function(e) {
    var kquestion = this.state.kquestion;
    kquestion.description = e.target.value;
  },
  onUpdateDescriptionContent: function(event) {
    var HTMLContent = event.editor.getData();
    var rawContent = HTMLContent;
    this.state.kquestion.description = HTMLContent;
    this.state.kquestion.metadata.description = rawContent;
    this.setState({
      kquestion: this.state.kquestion
    });
  },
  verifyQuestionData: function() {
    console.log('verify question data');
    var kquestion = this.state.kquestion;
    console.log(kquestion);
    kquestion.selectionChoices = [];
    if (!kquestion.textInputAnswers || kquestion.textInputAnswers.length === 0) {
      kquestion.textInputAnswers = [{
        preText: "",
        postText: "",
        text: ""
      }]
    }
    this.setState({
      kquestion: kquestion
    });
  },
  uploadImageDone: function(modelToBind, response) {
    modelToBind.isImageUploading = false;
    modelToBind.image = response.url;
    this.forceUpdate();
  },
  onUploadingImage: function(modelToBind) {
    modelToBind.isImageUploading = true;
    this.forceUpdate();
  },
  removeImage: function(model, e) {
    e.stopPropagation();
    model.image = '';
    this.forceUpdate();
  },
  getInitialState: function(){
    return {
      kquestion: this.props.kquestion
    }
  },
  componentWillReceiveProps: function(nextProps) {
    this.setState({
      kquestion: nextProps.kquestion
    })
  },
  componentWillMount: function() {
    //this.verifyQuestionData();
  },
  render: function() {
    var _this = this;
    return (
      <div className="question-content-container">
        <div className="row">
          <div className="col-md-6 col-xs-12">
            <ImageUploader onUploading={_this.onUploadingImage.bind(_this, _this.state.kquestion)} onUploadDone={_this.uploadImageDone.bind(_this, _this.state.kquestion)}>
              { !_this.state.kquestion.image &&
                <div>
                  <div className="img-intrinsic input intrinsic-2x1" style={{"background": "#ddd"}}>
                    {_this.state.kquestion.isImageUploading &&
                      <div className="intrinsic-item">
                        <CircularProgress className="loading"/>
                      </div>}
                  </div>
                  <div className="img-text-placehoder">
                      Click here to upload picture
                  </div>
                </div>
              }
              {
                _this.state.kquestion.image &&
                <div>
                  <div className="remove-image" data-tip data-for={"tt-remove-image-description"} onClick={_this.removeImage.bind(_this, _this.state.kquestion)}>
                    <i className="fa fa-remove"></i>
                  </div>
                  <img src={_this.state.kquestion.image} style={{"width": "100%"}} alt="Question"/>
                  <ReactTooltip id="tt-remove-image-description" effect="solid">Remove image</ReactTooltip>
                </div>
              }
            </ImageUploader>
          </div>
          <div className="col-md-6 col-xs-12">
          {(_this.state.kquestion.subtype && _this.state.kquestion.subtype.editor === 'old') ?
            <textarea className="form-control" placeholder="Enter question title here" rows="6" onChange={_this.handleDescriptionChange} defaultValue={_this.state.kquestion.description}></textarea>
            :
            <div>
              <label>Overall Description</label>
              <CustomEditor 
                activeClass="p10"
                content={_this.state.kquestion.description}
                isScriptLoaded={true}
                events={{
                  "change": _this.onUpdateDescriptionContent
                }}
              />
            </div>
          }  
          </div>
        </div>
        <hr/>
        <div className="choices">
          <div className="row">
            <div className="col-md-3"  >
              {_this.state.kquestion.subtype && _this.state.kquestion.subtype.editor === 'old' 
                ? <input className="form-control" type="text" placeholder="Pre-text" onChange={_this.handlePreTextChange} defaultValue={_this.state.kquestion.textInputAnswers[0].preText}/>
                : <input style={{marginTop:100}} className="form-control" type="text" placeholder="Pre-text" onChange={_this.handlePreTextChange} defaultValue={_this.state.kquestion.textInputAnswers[0].preText}/>

              }
            </div>
            <div className="col-md-6">

            {_this.state.kquestion.subtype && _this.state.kquestion.subtype.editor === 'old' 
              ?<input className="form-control" type="text" placeholder="Answer here" onChange={_this.handleAnswerChange} defaultValue={_this.state.kquestion.textInputAnswers[0].text}/>
              : <WirisEditor  className="form-control" type="text" placeholder="Answer here" onChange={_this.handleAnswerChangeWiris} content={_this.state.kquestion.textInputAnswers[0].text}/>
    
            }
            </div>
            <div className="col-md-3">
            {_this.state.kquestion.subtype && _this.state.kquestion.subtype.editor === 'old' 
              ?<input className="form-control" type="text" placeholder="Post-text" onChange={_this.handlePostTextChange} defaultValue={_this.state.kquestion.textInputAnswers[0].postText}/>
              :<input style={{marginTop:100}} className="form-control" type="text" placeholder="Post-text" onChange={_this.handlePostTextChange} defaultValue={_this.state.kquestion.textInputAnswers[0].postText}/>

            }
            </div>
          </div>
        </div>
        <hr/>
        {/*<Solution kquestion={_this.state.kquestion}/>*/}
        <Solution solution={_this.state.kquestion.solution} />
      </div>
    )
  },
  componentDidMount: function() {

  }
})

export default ShortQuestionEditor;



/** WEBPACK FOOTER **
 ** ./src/components/CollectionEditor/ShortQuestion.js
 **/